import { render, staticRenderFns } from "./StorageIn.vue?vue&type=template&id=ae85c952&scoped=true&"
import script from "./StorageIn.vue?vue&type=script&lang=js&"
export * from "./StorageIn.vue?vue&type=script&lang=js&"
import style0 from "./StorageIn.vue?vue&type=style&index=0&id=ae85c952&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae85c952",
  null
  
)

export default component.exports